import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on route (pathname) change, unless navigating to an in-page hash.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
};

export default ScrollToTop;
